import React from 'react';
import { ShadowBox } from './Privacy.style';
import PrivacyWrapper from './PrivacyContainer';
import { Helmet } from 'react-helmet';

export default function SafetyStandard({
  isLoggedIn,
  hideBackArrow,
  isAuthPage,
}) {
  return (
    <>
      <Helmet>
        <title>
            Safety Standard | WafyNet - Learn About Our Safety Standard
        </title>
        <meta
          name="description"
          content="Learn about WafyNet, our mission, our community values, and how we help users connect, grow businesses, and find opportunities."
        />
      </Helmet>
      <PrivacyWrapper
        isLoggedIn={isLoggedIn}
        hideBackArrow={hideBackArrow}
        isAuthPage={isAuthPage}
      >
        <ShadowBox isauthpage={isAuthPage}>
          <div style={{ fontSize: 15 }}>
            <h2>WafyNet Safety Standards</h2>
            <p>Last Updated: July 23, 2024</p>

            <h3>Our Commitment</h3>
            <p>
              At <strong>WafyNet</strong>, the safety and well-being of
              our users is our highest priority. We are committed to maintaining
              a safe, respectful, and inclusive community by enforcing strong
              protections against harmful or inappropriate behavior.
            </p>

            <h3>Child Safety</h3>
            <ul>
              <li>
                WafyNet is <strong>not intended for children under 13</strong>.
                Users must be at least 13 years of age to create an account, and
                in certain regions, the minimum age may be higher (e.g., 16 in
                the EU).
              </li>
              <li>
                We do{' '}
                <strong>
                  not knowingly collect or store personal information
                </strong>{' '}
                from children under the minimum age.
              </li>
              <li>
                If we discover that a child has created an account, we will{' '}
                <strong>delete the account and associated data</strong>{' '}
                immediately.
              </li>
              <li>
                Parents and guardians can contact us to review or request
                deletion of any child-related information.
              </li>
            </ul>

            <h3>Community Safety Standards</h3>
            <ul>
              <li>
                <strong>No harassment or abuse:</strong> We strictly prohibit
                bullying, threats, hate speech, and any form of harassment.
              </li>
              <li>
                <strong>No sexually explicit or harmful content:</strong>{' '}
                Sharing nudity, pornography, or exploitation of any kind is
                banned and will lead to immediate account action.
              </li>
              <li>
                <strong>Report & Block tools:</strong> Users can report or block
                inappropriate accounts or content directly in the app.
              </li>
              <li>
                <strong>Moderation & enforcement:</strong> We use both automated
                systems and human moderation to review flagged content and take
                necessary action.
              </li>
              <li>
                <strong>Transparency:</strong> Repeated violators will have
                accounts suspended or permanently banned.
              </li>
            </ul>

            <h3>Data Protection</h3>
            <p>
              All user data is handled in compliance with our{' '}
              <a href="https://www.wafynet.com/privacy-policy" target="_blank" rel="noreferrer">
              Privacy Policy
              </a>
              . We follow strict data security practices and never sell personal
              information.
            </p>

            <h3>How to Stay Safe</h3>
            <ul>
              <li>
                Never share passwords, financial information, or sensitive
                personal data with others.
              </li>
              <li>
                Report suspicious activity immediately using our in-app report
                tools or by contacting our support team.
              </li>
              <li>
                Use caution when interacting with people you don’t know
                personally.
              </li>
            </ul>

            <h3>Contact Information</h3>
            <p>
              If you have questions or concerns about safety on WafyNet, please
              contact us:
            </p>
            <ul>
              <li>
                Email:{' '}
                <a href="mailto:support@wafynet.com">support@wafynet.com</a>
              </li>
              <li>
                Website: <a href="https://www.wafynet.com">www.wafynet.com</a>
              </li>
            </ul>
          </div>
        </ShadowBox>
      </PrivacyWrapper>
    </>
  );
}
